



















































import { sleep } from '@/libs/util';
import DictMixin from '@/mixins/dict-mixin';
import DimensionServices from '@/services/dimension';
import { mixins } from 'vue-class-component';
import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class DimensionForm4 extends mixins(DictMixin) {
  @PropSync('syncDimSyncDefs') syncDimSyncDefs0!: any;
  @Prop() mode!: number;
  dimSrv = new DimensionServices();

  // sql = `SELECT APPLY_DATE AS APPLY_DATE, APPLY_CHANNEL AS CHANNEL, FROM SOURCE_TABLE WHERE ENABLED = 1;`;

  databases: string[] = [];
  sourceId: number = 1;
  async created() {
    let res = await this.dimSrv.getDatabaseList();
    this.databases = res.databases;
    this.sourceId = res.sourceId;
    this.source = this.syncDimSyncDefs0.sqlqueryConfig.source.name || '';
  }
  
  @Watch('mode')
  onModeChange() {
    this.source = this.syncDimSyncDefs0.sqlqueryConfig.source.name || '';
  }

  activeDatabase: string = '';
  tables: any[] = [];

  source: string = '';

  changeSource(e: string) {
    this.syncDimSyncDefs0.sqlqueryConfig.source.name = e;
    this.syncDimSyncDefs0.sqlqueryConfig.source.id = this.sourceId;
  }
}
